import { render, staticRenderFns } from "./picdemo.vue?vue&type=template&id=78bb1c1c"
import script from "./picdemo.vue?vue&type=script&lang=js"
export * from "./picdemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports